import React from "react";
import AltNavbar from "../components/AltNavbar";
import SideBar from "../components/SideBar";
import { Flex } from "@chakra-ui/react";
import CalendarComponent from "../components/Calendar";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getPosts } from "../redux/posts/post.action";

export const Publishing = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPosts());
  }, []);

  return (
    <div>
      <AltNavbar />
      <Flex justifyContent="space-between">
        <SideBar />
        <CalendarComponent />
      </Flex>
    </div>
  );
};
